import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface SuperAdminRouteProps {
  children: React.ReactNode;
}

export function SuperAdminRoute({ children }: SuperAdminRouteProps) {
  const { isAuthenticated, isLoading, isSuperAdmin } = useAuth();

  if (isLoading) return null;
  if (!isAuthenticated || !isSuperAdmin) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}
